import { SkeletonLoader } from '~/shared/components/SkeletonLoader';
import {
    DownloadDocuments,
    Filter,
    Footer,
    Header,
    PageSetter,
    Pagination,
    SearchContainer,
    Section,
    SkeletonSpacer,
    TableContainer,
    StyledTable,
} from '../styles';
import { Fragment } from 'react';
import { ModuleContainer } from '~/templates/blocks/shared/ModuleContainer';

export default function TableSkeleton() {
    return (
        <ModuleContainer spacingTop="none">
            <Section>
                <SkeletonLoader width={300} height={38} />
                <Header>
                    <SearchContainer>
                        <SkeletonLoader height={40} width={280} />
                    </SearchContainer>
                    <Filter>
                        <SkeletonLoader height={40} width={120} />
                    </Filter>

                    <SkeletonLoader height={40} width={210} />
                </Header>
                <DownloadDocuments>
                    <SkeletonLoader height={40} width={180} />
                </DownloadDocuments>
                <StyledTable>
                    <TableContainer>
                        {Array.from({ length: 11 }).map((_, index) => (
                            <Fragment key={index}>
                                <SkeletonLoader height={48} />
                                <SkeletonSpacer />
                            </Fragment>
                        ))}
                    </TableContainer>
                </StyledTable>
                <Footer>
                    <PageSetter>
                        <SkeletonLoader height={40} width={150} />
                    </PageSetter>
                    <Pagination>
                        <SkeletonLoader height={40} width={40} />
                        <SkeletonLoader height={40} width={150} />
                        <SkeletonLoader height={40} width={40} />
                    </Pagination>
                </Footer>
            </Section>
        </ModuleContainer>
    );
}
